module.exports = __webpack_public_path__ + "img/treatments-directory-icon-orange.d3ef2fa2.svg";